import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

// Connects to data-controller="status-select"
export default class extends Controller {
  connect() {
    let settings = {
      maxItems: 1,
      create: false,
      options: [
        { text: "New", value: "new", class: "border border-cw-purple-700 bg-cw-purple-200 text-cw-purple-800" },
        { text: "In Review", value: "in_review", class: "border border-blue-500 bg-blue-100 text-blue-700" },
        { text: "Offer", value: "offer", class: "border border-yellow-500 bg-yellow-200 text-yellow-800" },
        { text: "Hired", value: "hired", class: "border border-green-500 bg-green-100 text-green-700" },
        { text: "Pass", value: "reject", class: "border border-stone-500 bg-stone-200 text-stone-700" },
        { text: "Declined", value: "declined", class: "border border-red-500 bg-red-100 text-red-700" }
      ],
      render: {
        option: function (data, escape) {
          return '<div class="mb-1"><span class="px-1 py-0 rounded ' + data.class + '">' +
            escape(data.text) + '</span></div>';
        },
        item: function (data, escape) {
          return '<div><span class="px-1 py-0 rounded ' + data.class + '">' +
            escape(data.text) + '</span></div>';
        }
      }
    };
    new TomSelect(this.element, settings);
  }
}
